'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import EnseignesContent from './components/EnseignesContent';

export default function EnseignesPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur', 'Broker']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/enseignes">
        <EnseignesContent />
      </AppLayout>
    </RouteGuard>
  );
}
